var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRubleIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3125 8.68182H0.664773V7.27557H7.3125C7.92614 7.27557 8.43324 7.16903 8.83381 6.95597C9.23438 6.73864 9.53267 6.4446 9.72869 6.07386C9.92472 5.69886 10.0227 5.27273 10.0227 4.79545C10.0227 4.31818 9.92472 3.89418 9.72869 3.52344C9.53267 3.14844 9.23438 2.8544 8.83381 2.64134C8.43324 2.42401 7.92614 2.31534 7.3125 2.31534H4.32102V14H2.7358V0.909091H7.3125C8.28409 0.909091 9.08523 1.08594 9.71591 1.43963C10.3466 1.79332 10.8153 2.2642 11.1222 2.85227C11.429 3.44034 11.5824 4.08807 11.5824 4.79545C11.5824 5.50284 11.429 6.15057 11.1222 6.73864C10.8153 7.3267 10.3466 7.79759 9.71591 8.15128C9.08523 8.50497 8.28409 8.68182 7.3125 8.68182ZM7.21023 9.90909V11.3153H0.664773V9.90909H7.21023Z",
    fill: "#A653F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubleIco);
export default __webpack_public_path__ + "static/media/RubleIco.b56a79adaff0c067adc23e85f9880526.svg";
export { ForwardRef as ReactComponent };